"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggableError = void 0;
class LoggableError extends Error {
    constructor(message, log) {
        super(message);
        this.log = log;
        this.log.error(message);
    }
}
exports.LoggableError = LoggableError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2FibGUtZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbC9sb2dnYWJsZS1lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFhLGFBQWMsU0FBUSxLQUFLO0lBQ3BDLFlBQVksT0FBZSxFQUFVLEdBQVc7UUFDNUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBRGtCLFFBQUcsR0FBSCxHQUFHLENBQVE7UUFHNUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDNUIsQ0FBQztDQUNKO0FBTkQsc0NBTUMifQ==